/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown>, name: NonNullable<unknown> }} Seo_Service_DescriptionInputs */

const en_seo_service_description = /** @type {(inputs: Seo_Service_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} at ${i?.name}: price, length and open times. Book online.`)
};

const pl_seo_service_description = /** @type {(inputs: Seo_Service_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service}, ${i?.name}: cena, czas trwania i wolne terminy. Zarezerwuj online.`)
};

/**
* | output |
* | --- |
* | "{service} at {name}: price, length and open times. Book online." |
*
* @param {Seo_Service_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_service_description = /** @type {((inputs: Seo_Service_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Service_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_service_description(inputs)
	return en_seo_service_description(inputs)
});